// A Turbo visit (a Turbo-submitted form that redirects, or Turbo.visit) renders a new <body> and
// re-runs its scripts, but a module runs once per document. Code that sets up the page registers
// here: it runs now, and again each time the body_scripts_ran entry, the last <body> script,
// signals that Turbo re-ran them for a page it rendered.
const callbacks = [];

document.addEventListener('body-scripts:ran', () => {
  callbacks.forEach((callback) => callback());
});

export const onPageLoad = (callback) => {
  callbacks.push(callback);
  callback();
};
